import type { RetrievalQueueItem } from '@jq4race/shared';

import { formatWaitTime } from '../../domain/format-wait-time';
import { PickupRow } from './PickupRow';

interface QueueListProps {
  items: RetrievalQueueItem[];
  onClaim: (id: string) => void;
  claimingId: string | null;
}

export function QueueList({ items, onClaim, claimingId }: QueueListProps) {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <PickupRow
          key={item.id}
          ticketNumber={item.ticketNumber}
          plate={item.plate}
          zone={item.zone}
          waitTime={formatWaitTime(item.waitSeconds)}
          status="in-queue"
          qrTag={item.qrTag}
          onClaim={() => onClaim(item.id)}
          claiming={item.id === claimingId}
        />
      ))}
    </div>
  );
}
